import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, Loader2, Building2 } from "lucide-react";

/**
 * BLOC 19/10 — Super-admin : audit lecture seule des entreprises existantes.
 *
 * Lecture seule stricte. Pas de suppression, pas d'édition. Si Christophe
 * veut agir sur un tenant, il passe par Mongo direct ou endpoint dédié.
 */
export default function CompaniesAuditPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/companies-audit?limit=500");
        setItems(data);
      } catch (e) {
        if (e?.response?.status === 403) {
          setError("Accès réservé aux super-admins Wérko.");
        } else {
          setError(formatApiError(e));
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (error) {
    return (
      <div className="p-6" data-testid="audit-error">
        <div className="mx-auto max-w-xl rounded-lg border border-red-500/30 bg-red-500/10 p-6 text-red-200">
          <AlertTriangle className="mb-2 h-6 w-6" />
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6" data-testid="companies-audit-page">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-100">
          <Building2 className="h-6 w-6 text-[#C4553B]" />
          Audit entreprises
        </h1>
        <p className="text-sm text-slate-400">
          Vue lecture seule de toutes les Companies créées. {items.length} tenant(s).
        </p>
      </div>

      <Card className="border-slate-800 bg-slate-900/40">
        <CardContent className="p-0">
          {loading ? (
            <div className="p-10 text-center">
              <Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" />
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="border-b border-slate-800 text-slate-400">
                  <tr>
                    <th className="p-3 text-left">Nom</th>
                    <th className="p-3 text-left">Slug</th>
                    <th className="p-3 text-left">Créé le</th>
                    <th className="p-3 text-left">Admin créateur</th>
                    <th className="p-3 text-left">Nb users</th>
                    <th className="p-3 text-left">Dernière connexion</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((c) => (
                    <tr key={c.id} className="border-b border-slate-800/60 last:border-0">
                      <td className="p-3 font-medium text-slate-200">{c.name}</td>
                      <td className="p-3 font-mono text-xs text-slate-400">{c.slug}</td>
                      <td className="p-3 text-xs text-slate-500">
                        {new Date(c.created_at).toLocaleDateString("fr-BE")}
                      </td>
                      <td className="p-3 text-xs text-slate-400">{c.creator_email || "—"}</td>
                      <td className="p-3 text-center text-slate-200">{c.user_count}</td>
                      <td className="p-3 text-xs text-slate-500">
                        {c.last_user_login_at
                          ? new Date(c.last_user_login_at).toLocaleString("fr-BE", {
                              dateStyle: "short",
                              timeStyle: "short",
                            })
                          : "jamais"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
